import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

export const BrandMarquee = () => {
  const { t } = useLang();
  return (
    <div className="border-y border-white/10 bg-surface/40 py-6 overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill>
        {t.marquee.map((word, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading italic text-3xl md:text-5xl text-white/85 mx-8">
              {word}
            </span>
            <span className="text-brand text-3xl md:text-5xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
